import * as React from "react";
import {cs}       from "@Common/react/chain-services";

import {UseState}               from "@Common/react/use-state";
import {chain}                  from "@Common/utils/fs";
import {stateChangeNestedValue} from "@Common/react/state-change-nested-value";
import {randomId}               from "@Common/utils/random";
import {replaceIndex}           from "@Common/utils/collections";

import {Table}          from "./table/table";
import {convertRecords} from "../../common/convert-records";
import {plural}         from "../../../../../../language/plural";
import {ConfirmDialog}  from "../../../../../common/design2/dialogs/confirm-dialog/confirm-dialog";
import {SearchInput}    from "../../../../../common/design2/search-input/search-input";
import "./section-preview.scss";

export const SectionPreview = ({rows, keys, countryCode, modification, onClose}) => cs(
    ["records", (_, next) => next(convertRecords({modification: modification.value, rows, keys, countryCode}))],
    ["filter", (_, next) => UseState({next})],
    ["match", ({filter}, next) => next(!filter.value? (() => true) : (() => {
        const lowerCase = filter.value.toLowerCase();
        const attrs = [
            "firstname",
            "lastname",
            "company",
            "houseNum",
            "street",
            "aptNum",
            "city",
            "state",
            "zip",
        ];
        return (address) => (
            attrs.find((a) => address[a] && address[a].toLowerCase().includes(lowerCase))
        );
    })())],

    ["filteredRecords", ({records, match}, next) => next(chain(
        records,
        (_) => !match ? _ : _.filter((r) => match(r.address)),
    ))],
    ["confirmDialog", (_, next) => ConfirmDialog({next})],
    ({filter, filteredRecords, records, confirmDialog}) => (
        <div className="section-preview-a5oj">
            <div className="header">
                <div className="left">
                    <div className="title" xd-qa-type="label" xd-qa-name="Build Address List File Preview">
                        File Preview
                    </div>

                    <div className="sub-title" xd-qa-type="label" xd-qa-name="Build Address List File Preview Description">
                        If the addresses appear to be correct, select “Next”.
                    </div>
                </div>

                <div className="right">
                    {SearchInput({
                        state: filter,
                        placeholder: "Search List",
                        text: filter.value && <>Found <b>{filteredRecords.length}</b> {plural("address", filteredRecords.length)}</>,
                        xdQaName: "Build Address List Search List",
                    })}
                </div>
            </div>

            <div className="box">
                {/*<pre>{JSON.stringify(modification.value, null, 4)}</pre>*/}
                {Table({
                    records: filteredRecords,
                    countryCode,
                    onAdd: (address) => stateChangeNestedValue(modification, ["adds"], (_) => [..._, {
                        key: randomId(),
                        address,
                    }]),
                    onReplace: (r, newAddress) => r.type === "add" ? (
                        stateChangeNestedValue(modification, ["adds"], (_) => _.map((r1) => r1.key !== r.key ? r1 : ({
                            key: r1.key,
                            address: newAddress,
                        })))
                    ) : (
                        stateChangeNestedValue(modification, ["replaces"], (_) => {
                            const ri = _.findIndex((r1) => r1.index === r.index);
                            return ri === -1 ? (
                                [..._, {
                                    index: r.index,
                                    address: newAddress,
                                }]
                            ) : (
                                replaceIndex(ri, _, {
                                    index: r.index,
                                    address: newAddress,
                                })
                            );
                        })
                    ),
                    onReset: (r) => stateChangeNestedValue(modification, ["replaces"], (_) => _.filter((r1) => r1.index !== r.index)),
                    onDelete: async (address, r) => {
                        if( records.length > 1) {
                            if (
                                await confirmDialog.show({
                                    message: `Deleting address: ${address}`,
                                    actionName: "delete",
                                    buttons: {
                                        confirmLabel: "Yes",
                                    },
                                })
                            ) {
                                r.type === "add" ? (
                                    stateChangeNestedValue(modification, ["adds"], (_) => _.filter((r1) => r1.key !== r.key))
                                ) : (
                                    // stateChangeNestedValue(modification, ["deletes"], (_) => [..._, {index: r.index}]) // remove replaces
                                    modification.change((m) => ({
                                        ...m,
                                        deletes: [...m.deletes, {index: r.index}],
                                        replaces: m.replaces.filter((r1) => r1.index !== r.index),
                                    }))
                                )
                            }
                        } else {
                            if (
                                await confirmDialog.show({
                                    message: 'Removing this address will cancel the creation of this list.',
                                    actionName: "continue with this removal",
                                    buttons: {
                                        confirmLabel: "Yes",
                                    },
                                })
                            ) {
                                onClose();
                            }
                        }
                    }
                })}
            </div>
        </div>
    ),
);
